import axios from 'axios';
import { logoutHandler, setGlobalSchoolUtils } from 'utils/commonFunc';
import constants from '../../config/constants';

export const GET_ALL_SCHOOLS = 'GET_ALL_SCHOOLS';
export const GET_SCHOOL = 'GET_SCHOOL';
// Calendar
export const GET_ALL_CLNDR_ACTIVITIES = 'GET_ALL_CLNDR_ACTIVITIES';
// Events and Activities
export const GET_ALL_OTHER_ACTIVITIES = 'GET_ALL_OTHER_ACTIVITIES';

// Dashboard
// For counts
export const GET_CIRCULAR_COUNT_FOR_DASHBOARD = 'GET_CIRCULAR_COUNT_FOR_DASHBOARD';
export const GET_NOTICE_COUNT_FOR_DASHBOARD = 'GET_NOTICE_COUNT_FOR_DASHBOARD';
export const GET_TASK_COUNT_FOR_DASHBOARD = 'GET_TASK_COUNT_FOR_DASHBOARD';
export const GET_UPCOMING_EXAM_COUNT_FOR_DASHBOARD = 'GET_UPCOMING_EXAM_COUNT_FOR_DASHBOARD';
export const GET_UPCOMING_HOLIDAY_COUNT_FOR_DASHBOARD = 'GET_UPCOMING_HOLIDAY_COUNT_FOR_DASHBOARD';
// For data
export const GET_UPCOMING_CIRCULAR_FOR_3_DAYS = 'GET_UPCOMING_CIRCULAR_FOR_3_DAYS';
export const GET_UPCOMING_NOTICE_BOARD_FOR_3_DAYS = 'GET_UPCOMING_NOTICE_BOARD_FOR_3_DAYS';
export const GET_UPCOMING_EVENT_FOR_MONTH = 'GET_UPCOMING_EVENT_FOR_MONTH';
export const GET_UPCOMING_EXAM_FOR_MONTH = 'GET_UPCOMING_EXAM_FOR_MONTH';
export const GET_UPCOMING_HOLIDAY_FOR_MONTH = 'GET_UPCOMING_HOLIDAY_FOR_MONTH';
export const GET_UPCOMING_MEETING_FOR_WEEK = 'GET_UPCOMING_MEETING_FOR_WEEK';

// Fees
export const GET_COURSE_FEES = 'GET_COURSE_FEES';

//= ========== Reducer call functions begin ===========//
export const getAllSchools = schoolData => ({
  type: GET_ALL_SCHOOLS,
  schoolData,
});

export const getSchool = school => ({
  type: GET_SCHOOL,
  school,
});

// Calendar activities
export const getAllCalendarActivities = cActivities => ({
  type: GET_ALL_CLNDR_ACTIVITIES,
  cActivities,
});

// Other activities
export const getAllActivities = activities => ({
  type: GET_ALL_OTHER_ACTIVITIES,
  activities,
});

// Dashboard API
// For counts
export const getCircularCountForDashboard = circularCount => ({
  type: GET_CIRCULAR_COUNT_FOR_DASHBOARD,
  circularCount,
});

export const getNoticeboardCountForDashboard = noticeboardCount => ({
  type: GET_NOTICE_COUNT_FOR_DASHBOARD,
  noticeboardCount,
});

export const getTaskCountForDashboard = taskCount => ({
  type: GET_TASK_COUNT_FOR_DASHBOARD,
  taskCount,
});

export const getUpcomingExamCountForDashboard = upcomingExamCount => ({
  type: GET_UPCOMING_EXAM_COUNT_FOR_DASHBOARD,
  upcomingExamCount,
});

export const getUpcomingHolidayCountForDashboard = upcomingHolidayCount => ({
  type: GET_UPCOMING_HOLIDAY_COUNT_FOR_DASHBOARD,
  upcomingHolidayCount,
});

// For data's
export const getUpcomingCircularForNext3Days = upcomingCicularForNext3days => ({
  type: GET_UPCOMING_CIRCULAR_FOR_3_DAYS,
  upcomingCicularForNext3days,
});

export const getUpcomingNoticeboardForNext3Days = upcomingNoticeboardForNext3days => ({
  type: GET_UPCOMING_NOTICE_BOARD_FOR_3_DAYS,
  upcomingNoticeboardForNext3days,
});

export const getUpcomingEventForMonth = upcomingEventForMonth => ({
  type: GET_UPCOMING_EVENT_FOR_MONTH,
  upcomingEventForMonth,
});

export const getUpcomingExamForMonth = upcomingExamForMonth => ({
  type: GET_UPCOMING_EXAM_FOR_MONTH,
  upcomingExamForMonth,
});

export const getUpcomingHolidayForMonth = upcomingHolidayForMonth => ({
  type: GET_UPCOMING_HOLIDAY_FOR_MONTH,
  upcomingHolidayForMonth,
});

export const getUpcomingMeetingForWeek = upcomingMeetingForWeek => ({
  type: GET_UPCOMING_MEETING_FOR_WEEK,
  upcomingMeetingForWeek,
});

export const getCourseFees = fees => ({
  type: GET_COURSE_FEES,
  fees,
});

// Time table
export const GET_DAY_SLOTS = 'GET_DAY_SLOTS';
export const getDaySlots = daySlots => ({
  type: GET_DAY_SLOTS,
  daySlots,
});

export const GET_TIME_TABLE_EMPLOYEES = 'GET_TIME_TABLE_EMPLOYEES';
export const getTimeTableEmployees = timeTableEmployees => ({
  type: GET_TIME_TABLE_EMPLOYEES,
  timeTableEmployees,
});

export const GET_COURSE_FOR_TIME_TABLE = 'GET_COURSE_FOR_TIME_TABLE';
export const getCourseForTimeTable = timeTableCourses => ({
  type: GET_COURSE_FOR_TIME_TABLE,
  timeTableCourses,
});

export const GET_SUBJECT_FOR_TIME_TABLE = 'GET_SUBJECT_FOR_TIME_TABLE';
export const getSubjectForTimeTable = timeTableSubjects => ({
  type: GET_SUBJECT_FOR_TIME_TABLE,
  timeTableSubjects,
});

export const GET_SUBJECT_TEACHER_CLASS_FOR_TIME_TABLE = 'GET_SUBJECT_TEACHER_CLASS_FOR_TIME_TABLE';
export const getSubjectTeacherClassForTimeTable = timeTableSubjectTeacherClass => ({
  type: GET_SUBJECT_TEACHER_CLASS_FOR_TIME_TABLE,
  timeTableSubjectTeacherClass,
});
//=========== Reducer call functions begin ===========//

//= ========== User routing begin ===========//
export const fetchAllSchoolsService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/all-school-by-page${constants.makeParams(data.pageParams)}`,
      constants.setHeader(data.token)
    );
    if (res?.data?.content?.length) {
      setGlobalSchoolUtils(res?.data?.content?.[0]);
    }
    dispatch(getAllSchools(res.data));
    return res.data;
  } catch (err) {
    console.error('fetchAllSchoolsService', err?.response);
  }
};

export const saveSchoolService = data => () => {
  return axios.post(
    `${constants.API_BASE_URL}/api/admin/create-school`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const fetchSchoolService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/get-school/${data.schoolId}`,
      constants.setHeader(data.token)
    );
    dispatch(getSchool(res.data));
    res?.data?.schoolId && setGlobalSchoolUtils(res?.data);
    return res.data;
  } catch (err) {
    logoutHandler(err);
    return err;
  }
};

export const updateSchoolService = data => () => {
  return axios.put(
    `${constants.API_BASE_URL}/api/admin/update-school/${data.schoolId}`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const deleteSchoolService = data => () => {
  return axios.delete(
    `${constants.API_BASE_URL}/api/admin/delete-school/${data.schoolId}`,
    constants.setHeader(data.token)
  );
};

// Calendar activity
export const fetchAllCalendarActivityService = data => async dispatch => {
  const { year } = data;
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/admin/activity-calendar/${data.activityType}/${year}`,
    constants.setHeader(data.token)
  );
  return dispatch(getAllCalendarActivities(res.data));
};

export const saveCalendarActivityService = data => () => {
  return axios.post(
    `${constants.API_BASE_URL}/api/admin/activity-calendar`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const deleteCalendarActivityService = data => () => {
  return axios.delete(
    `${constants.API_BASE_URL}/api/admin/activity-calendar/${data.calendatId}`,
    constants.setHeader(data.token)
  );
};

// Other Activities
export const fetchAllOtherActivitiesService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/extra-curricular-activities/${data.schoolId}`,
      constants.setHeader(data.token)
    );
    dispatch(getAllActivities(res.data));
  } catch (err) {
    console.error('err-fetchAllActivitiesService-err', err?.response);
  }
};

export const saveOtherActivityService = data => () => {
  return axios.post(
    `${constants.API_BASE_URL}/api/admin/extra-curricular-activity/${data.schoolId}`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const deleteOtherActivityService = data => () => {
  return axios.delete(
    `${constants.API_BASE_URL}/api/admin/extra-curricular-activity/${data.extracurricularId}`,
    constants.setHeader(data.token)
  );
};

// Dashboard api's
export const dashboardAPIController = new AbortController();

// Counts
export const fetchCircularCountForDashboardService = data => async dispatch => {
  const { token, schoolId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/dashboard/circular-counts/${schoolId}`,
      constants.setHeader(token, null, null, dashboardAPIController)
    );
    dispatch(getCircularCountForDashboard(res.data));
  } catch (err) {
    console.error(err);
    console.error(err?.response);
  }
};

export const fetchNoticeboardCountForDashboardService = data => async dispatch => {
  const { token, schoolId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/dashboard/notice-board-counts/${schoolId}`,
      constants.setHeader(token, null, null, dashboardAPIController)
    );
    dispatch(getNoticeboardCountForDashboard(res.data));
  } catch (err) {
    console.error(err?.response);
  }
};

export const fetchTaskCountForDashboardService = data => async dispatch => {
  const { token, schoolId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/dashboard/task-counts/${schoolId}`,
      constants.setHeader(token, null, null, dashboardAPIController)
    );
    dispatch(getTaskCountForDashboard(res.data));
  } catch (err) {
    console.error(err?.response);
  }
};

export const fetchUpcomingExamCountForDashboardService = data => async dispatch => {
  const { token, schoolId, batchId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/dashboard/upcoming-exam-counts/${schoolId}/${batchId}`,
      constants.setHeader(token, null, null, dashboardAPIController)
    );
    dispatch(getUpcomingExamCountForDashboard(res.data));
  } catch (err) {
    console.error(err);
    console.error(err?.response);
  }
};

export const fetchUpcomingHolidayCountForDashboardService = data => async dispatch => {
  const { token, schoolId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/dashboard/upcoming-holiday-counts/${schoolId}`,
      constants.setHeader(token, null, null, dashboardAPIController)
    );
    dispatch(getUpcomingHolidayCountForDashboard(res.data));
  } catch (err) {
    console.error(err?.response);
  }
};

// Data's
export const fetchUpcomingCircularForNext3DaysService = data => async dispatch => {
  const { token, schoolId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/dashboard/latest-circular/${schoolId}`,
      constants.setHeader(token, null, null, dashboardAPIController)
    );
    dispatch(getUpcomingCircularForNext3Days(res.data));
  } catch (err) {
    console.error(err?.response);
  }
};

export const fetchUpcomingNoticeboardForNext3DaysService = data => async dispatch => {
  const { token, schoolId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/dashboard/latest-notice-board/${schoolId}`,
      constants.setHeader(token, null, null, dashboardAPIController)
    );
    dispatch(getUpcomingNoticeboardForNext3Days(res.data));
  } catch (err) {
    console.error(err?.response);
  }
};

export const fetchUpcomingEventForMonthService = data => async dispatch => {
  const { token, schoolId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/dashboard/upcoming-events-for-month/${schoolId}`,
      constants.setHeader(token, null, null, dashboardAPIController)
    );
    dispatch(getUpcomingEventForMonth(res.data));
  } catch (err) {
    console.error(err?.response);
  }
};

export const fetchUpcomingExamForMonthService = data => async dispatch => {
  const { token, schoolId, batchId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/dashboard/upcoming-exams-for-month/${schoolId}/${batchId}`,
      constants.setHeader(token, null, null, dashboardAPIController)
    );
    dispatch(getUpcomingExamForMonth(res.data));
  } catch (err) {
    console.error(err?.response);
  }
};

export const fetchUpcomingHolidayForMonthService = data => async dispatch => {
  const { token, schoolId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/dashboard/upcoming-holiday-for-month/${schoolId}`,
      constants.setHeader(token, null, null, dashboardAPIController)
    );
    dispatch(getUpcomingHolidayForMonth(res.data));
  } catch (err) {
    console.error(err?.response);
  }
};

export const fetchUpcomingMeetingForWeekService = data => async dispatch => {
  const { token, schoolId, batchId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/dashboard/upcoming-meetings-for-week/${schoolId}/${batchId}`,
      constants.setHeader(token)
    );
    dispatch(getUpcomingMeetingForWeek(res.data));
  } catch (err) {
    console.error(err?.response);
  }
};

// Fees // @Note: Deleted
export const fetchCourseFeesService = data => async dispatch => {
  const { token, schoolId, courseId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/fee-structure/${schoolId}/${courseId}`,
      constants.setHeader(token)
    );
    dispatch(getCourseFees(res.data));
  } catch (err) {
    console.error(err?.response);
  }
};

export const saveFeesService = data => async () => {
  const url = `${constants.API_BASE_URL}/api/admin/create-fee-structure`;
  return await axios.post(url, data.postData, constants.setHeader(data.token));
};

// Time table
export const fetchDaySlotsService = data => async dispatch => {
  const { token, schoolId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/time-table/day-slots/${schoolId}`,
      constants.setHeader(token)
    );
    dispatch(getDaySlots(res.data));
  } catch (err) {
    console.error(err?.response);
  }
};

export const updateDaySlotsService = data => async () => {
  const { token, postData, schoolId } = data;
  return axios.put(
    `${constants.API_BASE_URL}/api/admin/time-table/day-slots/${schoolId}`,
    postData,
    constants.setHeader(token)
  );
};

export const fetchTimeTableEmployeesService = data => async dispatch => {
  const { token, schoolId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/time-table/teachers/${schoolId}`,
      constants.setHeader(token)
    );
    dispatch(getTimeTableEmployees(res.data));
  } catch (err) {
    console.error(err?.response);
  }
};

export const updateTimeTableEmployeesService = data => async () => {
  const { token, postData, schoolId } = data;
  return axios.put(
    `${constants.API_BASE_URL}/api/admin/time-table/teachers/${schoolId}`,
    postData,
    constants.setHeader(token)
  );
};

export const fetchCourseForTimeTableService = data => async dispatch => {
  const { token, schoolId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/time-table/theory-practical-classes/${schoolId}`,
      constants.setHeader(token)
    );
    dispatch(getCourseForTimeTable(res.data));
  } catch (err) {
    console.error(err?.response);
  }
};

export const fetchSubjectForTimeTableService = data => async dispatch => {
  const { token, schoolId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/time-table/subjects/${schoolId}`,
      constants.setHeader(token)
    );
    dispatch(getSubjectForTimeTable(res.data));
  } catch (err) {
    console.error(err?.response);
  }
};

export const updateCourseForTimeTableService = data => () => {
  const { token, courses, schoolId } = data;
  return axios.put(
    `${constants.API_BASE_URL}/api/admin/time-table/theory-practical-classes/${schoolId}`,
    courses,
    constants.setHeader(token)
  );
};

export const updateSubjectForTimeTableService = data => () => {
  const { token, subjects, schoolId } = data;
  return axios.put(
    `${constants.API_BASE_URL}/api/admin/time-table/subjects/${schoolId}`,
    subjects,
    constants.setHeader(token)
  );
};

export const fetchSubjectTeacherClassForTimeTableService = async data => {
  const { token, schoolId, dispatch } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/time-table/subject-teacher-class/${schoolId}`,
      constants.setHeader(token)
    );
    dispatch(getSubjectTeacherClassForTimeTable(res.data));
  } catch (err) {
    console.error('fetchSubjectTeacherClassForTimeTableService', err?.response);
  }
};

export const createTeacherSubjectClassService = data => () => {
  const { token, schoolId } = data;
  return axios.post(
    `${constants.API_BASE_URL}/api/admin/time-table/assign-subject-teacher-class/${schoolId}`,
    null,
    constants.setHeader(token)
  );
};

export const updateTeacherSubjectClassService = data => () => {
  const { token, schoolId, postData } = data;
  return axios.put(
    `${constants.API_BASE_URL}/api/admin/time-table/update-subject-teacher-class/${schoolId}`,
    postData,
    constants.setHeader(token)
  );
};

export const generateTimeTableService = data => () => {
  const { token, schoolId } = data;
  return axios.post(`${constants.API_BASE_URL}/api/admin/time-table/generate/${schoolId}`, null, {
    responseType: 'arraybuffer',
    ...constants.setHeader(token),
  });
};

///** Search school students */
export const searchSchoolStudentsService = async data => {
  const { batchId, searchKeyWord, token, schoolId } = data;
  const res = await axios.post(
    `${constants.API_BASE_URL}/api/admin/search-school-student-by-filter/${schoolId}`,
    {
      batchId,
      searchKeyWord,
    },
    constants.setHeader(token)
  );
  return res.data;
};

/****** Appreciation *********/

export const GET_ALL_APPRECIATIONS_TEMPLATES = 'GET_ALL_APPRECIATIONS_TEMPLATES';
export const getAllAppreciation = appreciationTemplates => {
  return {
    type: GET_ALL_APPRECIATIONS_TEMPLATES,
    appreciationTemplates,
  };
};
export const fetchAllAppreciationTemplatesService = async data => {
  const { dispatch, token, schoolId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/user/all-appreciation-template/${schoolId}`,
      constants.setHeader(token)
    );
    dispatch(getAllAppreciation(res.data));
    return res.data;
  } catch (err) {
    console.error(err?.response);
  }
};

// Create || Update
export const addOrUpdateAppreciationTemplateService = data => {
  const { token, appreciation, schoolId, action, appreTemplateId: passAppreTemplateId } = data;
  const appreTemplateId = appreciation?.appreTemplateId || passAppreTemplateId || 0;
  const url =
    action === 'create'
      ? `/api/user/appreciation-template/${schoolId}`
      : `/api/user/appreciation-template/${schoolId}/${appreTemplateId}`;
  return axios[action === 'create' ? 'post' : 'put'](
    `${constants.API_BASE_URL}${url}`,
    {
      schoolId,
      templateJson: action === 'create' ? appreciation : JSON.stringify(appreciation),
      toWhom: appreciation?.toWhom,
      appreTemplateId,
    },
    constants.setHeader(token)
  );
};

export const GET_APPREICATION = 'GET_APPREICATION';
export const getAppreciation = appreciation => {
  return {
    type: GET_APPREICATION,
    appreciation,
  };
};
export const fetchAppreciationTemplateService = async data => {
  const { dispatch, token, appreTemplateId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/user/appreciation-template/${appreTemplateId}`,
      constants.setHeader(token)
    );
    dispatch(getAppreciation(res.data));
    return res.data;
  } catch (err) {
    console.error(err?.response);
  }
};

export const deleteAppreciationTemplateService = data => {
  const { token, appreTemplateId } = data;
  return axios.delete(
    `${constants.API_BASE_URL}/api/user/appreciation-template/${appreTemplateId}`,
    constants.setHeader(token)
  );
};

export const GET_ALL_APPRECIATIONS_ASSIGNS = 'GET_ALL_APPRECIATIONS_ASSIGNS';
export const getAllAppreciationAssigns = appreciationAssigns => {
  return {
    type: GET_ALL_APPRECIATIONS_ASSIGNS,
    appreciationAssigns,
  };
};
export const fetchAllAppreciationAssignsService = async data => {
  const { dispatch, token, schoolId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/user/all-appreciation-template/${schoolId}`,
      constants.setHeader(token)
    );
    dispatch(getAllAppreciationAssigns(res.data));
    return res.data;
  } catch (err) {
    console.error(err?.response);
  }
};

// Save as draft
export const GET_APPRECIATION_CARD = 'GET_APPRECIATION_CARD';
export const getAppreciationCard = appreciationCard => {
  return {
    type: GET_APPRECIATION_CARD,
    appreciationCard,
  };
};
export const fetchAppreciationCardService = async data => {
  const { dispatch, token, appreciationId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/user/appreciation-card/${appreciationId}`,
      constants.setHeader(token)
    );
    dispatch(getAppreciationCard(res.data));
    return res.data;
  } catch (err) {
    console.error(err?.response);
  }
};

export const saveAppreciationAsDraftService = async data => {
  const { token, appreciationCard, schoolId, batchId } = data;
  const res = await axios.post(
    `${constants.API_BASE_URL}/api/user/appreciation-card/${schoolId}/${batchId}`,
    appreciationCard,
    constants.setHeader(token)
  );
  return res.data;
};

// Assign
export const sendAppreciationCardService = data => {
  const { token, appreciationCard, schoolId } = data;
  const { appreciationId, toUserId, toUserRole } = appreciationCard;
  const url = `/api/user/send-appreciation-card/${schoolId}/${appreciationId}/${toUserId}/${toUserRole}`;
  return axios.post(`${constants.API_BASE_URL}${url}`, null, constants.setHeader(token));
};

// Get appreciations

export const fetchDraftAppreciationsApi = async data => {
  const { token, fromUserId, userId, batchId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/user/student-draft-item-appreciation/${fromUserId}/${userId}/${batchId}`,
      constants.setHeader(token)
    );
    return res.data;
  } catch (err) {
    console.error(err?.response);
  }
};

export const fetchReceivedAppreciationsApi = async data => {
  const { token, userId, batchId, roleName = 'ROLE_TEACHER' } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/user/received-item-appreciation/${userId}/${roleName}/${batchId}`,
      constants.setHeader(token)
    );
    return res.data;
  } catch (err) {
    console.error(err?.response);
  }
};

export const deleteAppreciationCardService = data => {
  const { token, appreciationId } = data;
  return axios.delete(
    `${constants.API_BASE_URL}/api/user/appreciation-card/${appreciationId}`,
    constants.setHeader(token)
  );
};
//= ========== User routing end ===========//
